import { Country } from '../../../types';

const COLOR_DEFAULT = '#E8EEF5';
const DARK_COLOR_DEFAULT = '#42464F';

const lightStrokeStyles = { strokeWidth: 0.5, stroke: '#fff' };
const darkStrokeStyles = { strokeWidth: 0.5, stroke: '#1F2226' };

interface GeographyFeature {
  properties?: { ISO_A2?: string };
}

interface GetGeogrpahyStylesArguments {
  geo: GeographyFeature;
  data: Country[];
  isLightTheme: boolean;
}

export const getGeogrpahyStyles = ({
  data,
  geo,
  isLightTheme,
}: GetGeogrpahyStylesArguments) => {
  const countryColor = data.find(
    item => item.isoA2 === geo?.properties?.ISO_A2,
  )?.color;

  const strokeStyles = isLightTheme ? lightStrokeStyles : darkStrokeStyles;

  const cursorStyle = countryColor ? 'pointer' : 'default';
  const fillColor =
    countryColor || (isLightTheme ? COLOR_DEFAULT : DARK_COLOR_DEFAULT);

  return {
    default: { fill: fillColor, ...strokeStyles, cursor: cursorStyle },
    hover: {
      fill: fillColor,
      cursor: cursorStyle,
      ...strokeStyles,
    },
    pressed: {
      fill: fillColor,
      outline: 'none',
      cursor: cursorStyle,
      ...strokeStyles,
    },
    hasColor: Boolean(countryColor),
  };
};
